module.exports = __webpack_public_path__ + "img/chat.6d577d54.svg";